"use client";

import "swiper/css";
import "swiper/css/navigation";

import {  useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Car } from "../../../../public/models/Car";
import CarPageWrapper from "../../../../public/components/CarPageWrapper";

export default function CarPageClient({ cars }: { cars: Car[] }) {
    const prevRef = useRef<HTMLDivElement>(null);
    const nextRef = useRef<HTMLDivElement>(null);


    return (
        <div className="container mx-auto relative bg-white  p-[0.5rem] sm:rounded-[4rem] sm:p-[2rem]">
            {/* Navigation buttons */}
            <div
                ref={prevRef}
                className="absolute top-4 left-4 w-[50px] h-[50px] flex items-center justify-center z-10 cursor-pointer bg-[#c8c8c8] text-white rounded-full"
            >
                <ChevronLeft style={{ fontSize: '36px' }} />
            </div>
            <div
                ref={nextRef}
                className="absolute top-4 right-4 w-[50px] h-[50px] flex items-center justify-center z-10 cursor-pointer bg-[#c8c8c8] text-white rounded-full"
            >
                <ChevronRight style={{ fontSize: '36px' }} />
            </div>

            {/* Swiper */}
            <Swiper
                spaceBetween={30}
                slidesPerView={1}
                loop={true}
                modules={[Navigation]}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                }}
                onInit={(swiper) => {
                    // Force attach navigation refs
                    // @ts-expect-error - Swiper types don't recognize dynamic ref assignment
                    swiper.params.navigation.prevEl = prevRef.current;
                    // @ts-expect-error - Swiper types don't recognize dynamic ref assignment
                    swiper.params.navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                }}
                className="w-full"
                style={{ marginBottom: "1rem" }}
                onSlideChange={(swiper) => {
                    const currentCar = cars[swiper.realIndex];
                    window.history.pushState(null, '', `/cars/${encodeURIComponent(currentCar.uniqueName)}`);
                }}
            >
                {cars.map((el, index) => (
                    <SwiperSlide key={index} className="h-[400px] flex items-center">
                        <CarPageWrapper car={el} />
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* <div className="mt-8">
                <CarList cars={cars} />
            </div> */}
        </div>
    );
}
